export const translateStatus = (status: number) => {
  switch (status) {
    case 0:
      return 'Mới tạo';
    case 1:
      return 'Lưu nháp';
    case 2:
      return 'Đã phân bổ';
  }
};

export const translateAllocateStatus = (status: number) => {
  if (status == null || status == undefined) return null;
  else
    switch (status) {
      case 0:
        return 'Đang phân bổ';
      case 1:
        return 'Hoàn thành';
    }
};
